/**
 * 이벤트
 */
import { Fragment } from 'react';
import { useLoaderData } from 'react-router-dom';
import Header from '@features/content/Header';
import { apiSearchSlice } from '@features/api/apiSearchSlice';
import { setRequestToSearchParams } from '@utils/index';
import { ALIAS, CUR_NETWORK, NETWORK } from '@constants/index';
import { getLocalData } from '@features/api/apiLocalSlice';
import NoData from '../../components/contents/common/NoData';
import { useAppSelector } from '@hooks/defineRtkTypedHook';
import { selectL10N, setAlias } from '@features/ui/UiSlice';
import EventArticle from '@components/contents/article/EventArticle';
import Paging from '@components/contents/common/Paging';
import type { IContentData, IEvent, ILoaderData } from '@type/index';

export const EventLoader =
  (dispatch, option: IOption) =>
  async ({ request }): Promise<IEvent | null> => {
    // alias 변경 - searchParams 변경에 사용됨
    dispatch(setAlias(ALIAS.EVENT));

    const searchParams = setRequestToSearchParams(request);
    if (!searchParams?.keyword) {
      return null;
    }

    return CUR_NETWORK === NETWORK.OPDEV
      ? await getLocalData(ALIAS.EVENT, searchParams)
      : await dispatch(apiSearchSlice?.endpoints?.getEvent?.initiate({ option, params: searchParams }));
  };

interface IContentComponentProps {
  data: IContentData<IEvent>;
}
const ContentComponent = ({ data }: IContentComponentProps) => {
  const l10n = useAppSelector(selectL10N);

  return (
    <Fragment>
      <div className="search-content">
        <ul className="column column-2">
          {data?.list.map((item, i) => (
            <li key={i} className="search-item">
              <EventArticle item={item} />
            </li>
          ))}
        </ul>
      </div>
      <Paging endPage={data?.pagination?.endPage} showPage={5} l10n={l10n!} />
    </Fragment>
  );
};

const Event = () => {
  const { data, isLoading, isError } = (useLoaderData() as ILoaderData<IContentData<IEvent>>) || {};

  console.log('Event Data', data);

  if (isError || !Array.isArray(data?.list) || data?.list?.length === 0) {
    return <NoData />;
  }

  return (
    <div className="search-result event">
      <Header totalCount={data?.pagination?.total} />
      <ContentComponent data={data} />
    </div>
  );
};

export default Event;
